const { sanitizeCnpj } = require('@/utils/nfeSanitizers');

let emitterNFce = {
  cnpjEmitter: "",
};

async function execute(cnpj) {
  if (!cnpj) {
    throw "Favor informar cnpj do emitente";
  }
  emitterNFce.cnpjEmitter = sanitizeCnpj(cnpj);
  return emitterNFce;
}

module.exports = {
  execute,
};
